<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')"
    >
      <template slot="links">
        <sidebar-item
        v-for="(item, index) in sidebarItems"
        :key="index"
        :link="{
          name: item.name,
          icon: item.icon,
          path: item.path.replace('/pages', '')
        }"
      ></sidebar-item>
      <sidebar-item
          :link="{
            name: 'LOZINKA',
            icon: 'tim-icons icon-badge',
            path: '/user'
          }"
        >
        </sidebar-item>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
      <!-- <pre>{{ sidebarItems }}</pre> -->

        <!-- <sidebar-item
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/dashboard'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'tim-icons icon-chart-pie-36',
            path: '/scanCarDashboard'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Doplatne karte',
            icon: 'tim-icons icon-badge',
            path: '/tickets'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Digitalne karte',
            icon: 'tim-icons icon-badge',
            path: '/kioskTickets'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'SMS karte',
            icon: 'tim-icons icon-badge',
            path: '/smsTickets'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Pretplatnici',
            icon: 'tim-icons icon-bag-16',
            path: '/customers'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Besplatne karte',
            icon: 'tim-icons icon-gift-2',
            path: '/freeCustomers'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Radni nalozi',
            icon: 'tim-icons icon-paper',
            path: '/workOrders'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Opomene',
            icon: 'tim-icons icon-paper',
            path: '/warnings'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Zone', icon: 'tim-icons icon-image-02' }"
        >
          <sidebar-item
              :link="{ name: 'Zone', path: '/pages/zones' }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: 'Sektori', path: '/pages/sectors' }"
            ></sidebar-item>

            <sidebar-item
              :link="{ name: 'Korisnici', path: '/pages/users' }"
            ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{ name: $t('sidebar.pages'), icon: 'tim-icons icon-image-02' }"
        >
          
          <sidebar-item
            :link="{ name: $t('sidebar.administration'), path: '/pages/administration' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Tipovi pretplatnih karata', path: '/pages/whitelistTypes' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Grupe besplatnih karata', path: '/pages/whitelistCategories' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Rent-a-car', path: '/pages/rentCar' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Vlasnici vozila', path: '/pages/plateOwners' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Praznici', path: '/pages/holidays' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Mapa', path: '/pages/scanCar' }"
          ></sidebar-item>
        
        </sidebar-item> -->
        
      </template>
    </side-bar>
    <!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->
    <sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import SidebarShare from './SidebarSharePlugin';
import axios from '@/util/axiosinstance'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
    SidebarShare
  },
  data() {
    return {
      sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
      sidebarItems: [],
      url: 'https://budva.scancar.org:8443/kuca',

    };
  },
  methods: {
    getUserPages(){
      
      axios.get(this.url + '/user/getCurrentUserPages').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.sidebarItems = result.data.pages
                    console.log(this.sidebarItems);
                    if(this.sidebarItems !== '/dashboard'){
                      if(this.$route.path === '/dashboard'){
                        this.$router.push({ path: this.sidebarItems[0].path });
                        // alert("REDITRE")
                        // this.$router.push({ name: 'Tickets'});

                      }
                    }
                    this.initScrollbar();

                } else {

                }
            })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  mounted() {
    this.getUserPages()
    // this.initScrollbar();
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
